import { render, staticRenderFns } from "./DevExpressPivot.vue?vue&type=template&id=94611cdc&"
import script from "./DevExpressPivot.vue?vue&type=script&lang=js&"
export * from "./DevExpressPivot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports